module.exports = __webpack_public_path__ + "static/media/me_about.731ea47c.png";